module.exports = __webpack_public_path__ + "img/butcher-icon.39814a2b.svg";